<template>
  <v-card flat rounded="lg" outlined class="mt-2">
    <v-list-item :three-line="isMobile()">
      <v-list-item-content>
        <v-list-item-title class="font-weight-bold">{{
          pedido.nome_cliente
        }}</v-list-item-title>
        <v-list-item-subtitle
          >Pedido {{ pedido.nr_pedido }}</v-list-item-subtitle
        >
        <v-item-subtitle v-if="isMobile()">
          <btn-local-cliente-form-carga :pedido="pedido" />
        </v-item-subtitle>
      </v-list-item-content>
      <v-list-item-action v-if="!isMobile()">
        <btn-local-cliente-form-carga :pedido="pedido" />
      </v-list-item-action>
    </v-list-item>
    <v-card-text class="pt-0">
      <v-data-table
        :headers="headers"
        :items="pedido.itens"
        no-data-text="Nenhum pedido adicionado"
        dense
        hide-default-footer
        disable-sort
      >
      </v-data-table>
    </v-card-text>
  </v-card>
</template>

<script>
import { mapState } from "vuex";
import BtnLocalClienteFormCarga from "./BtnLocalClienteFormCarga.vue";
export default {
  props: {
    pedido: Object,
  },
  components: { BtnLocalClienteFormCarga },
  computed: {
    ...mapState("formacaoCarga", ["pedidosAdicionados"]),
  },
  data: () => ({
    headers: [
      { text: "Produto", value: "produto" },
      { text: "Embalagem", value: "embalagem" },
      { text: "Qtde(kgs)", value: "quantidade" },
    ],
  }),
  methods: {
    isMobile() {
      return this.$mq == "sm";
    },
  },
};
</script>

<style>
</style>